import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement('as-loading-indicator')
export class LoadingIndicator extends LitElement {
  public static styles = css`
    @keyframes loading-indicator {
      0% {
        left: -100%;
      }

      100% {
        left: 100%;
      }
    }

    .loading-indicator {
      background-color: #e0e0e0;
      height: 4px;
      width: 100%;
      position: relative;
      overflow: hidden;

      &::before {
        display: block;
        content: '';
        background-color: #e30917;
        height: 4px;
        width: 100%;
        left: -100%;
        position: absolute;
        animation-name: loading-indicator;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: ease-in-out;
      }

      &.primary::before {
        background-color: #1467ba;
      }
    }
  `;

  @property({ type: Boolean })
  public primary = false;

  @property()
  public label: string | undefined;

  @property({ type: Boolean })
  public invisible = false;

  public render() {
    if (this.invisible) {
      return undefined;
    }

    const classes = classMap({
      'loading-indicator': true,
      primary: this.primary
    });

    return html`<div class="${classes}" aria-label="${ifDefined(this.label)}" aria-live="polite"></div>`;
  }
}
